import React from "react";

// Authentic WhatsApp brand icon (SVG)
export default function WhatsAppIcon({ className = "w-5 h-5", filled = true }) {
  return (
    <svg
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <path
        fill={filled ? "currentColor" : "none"}
        d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.888 2.722.888.517 0 2.15-.43 2.478-.955.244-.386.315-.816.315-1.246 0-.688-.688-.888-1.203-1.055Zm-3.278 6.05c-1.918 0-3.62-.552-5.191-1.591l-3.626 1.161 1.19-3.51c-1.132-1.635-1.72-3.55-1.72-5.499 0-5.242 4.32-9.503 9.532-9.503 5.24 0 9.53 4.267 9.53 9.502 0 5.243-4.32 9.44-9.715 9.44Zm0-20.83C9.494 2.425 4.2 7.663 4.2 14.11c0 2.152.542 4.196 1.6 6l-2.03 5.97 6.185-1.968a11.71 11.71 0 0 0 5.677 1.475c6.338 0 11.652-5.24 11.652-11.578 0-3.086-1.263-5.998-3.454-8.183a11.628 11.628 0 0 0-8.198-3.4Z"
      />
    </svg>
  );
}
